import { formatFHIRDate } from '@ctw/shared/utils/dates';
import type { MedicationAdministration } from 'fhir/r4';
import { compact } from 'lodash-es';
import { getMedicationDisplayName } from '../medication';
import { FHIRModel } from './fhir-model';

export class MedicationAdministrationModel extends FHIRModel<MedicationAdministration> {
  public kind = 'MedicationAdministration' as const;

  public get dosageDisplay(): string {
    const { text, dose } = this.resource.dosage || {};
    if (text) {
      return text;
    }

    return compact([dose?.value, dose?.unit]).join(' ');
  }

  public get dosageRoute(): string | undefined {
    const { route } = this.resource.dosage || {};
    return route?.text;
  }

  public get effectivePeriod() {
    const { start, end } = this.resource.effectivePeriod || {};

    return {
      start: start ? formatFHIRDate(start) : '',
      end: end ? formatFHIRDate(end) : '',
    };
  }

  public get title() {
    return getMedicationDisplayName(this.resource, this.includedResources);
  }
}
